import { Component } from '@angular/core';

/**
 * Decorative falling confetti. Fills its nearest positioned ancestor, so drop
 * it in as a direct child of a page wrapper and give the content above it a
 * higher z-index.
 */
@Component({
  selector: 'app-confetti',
  templateUrl: './confetti.component.html',
  styleUrl: './confetti.component.scss',
})
export class ConfettiComponent {
  // No rule in the stylesheet names a piece number, so any count works;
  // more pieces just means denser confetti.
  protected readonly pieces = Array.from({ length: 32 }, (_, i) => i);
}
